import React, { useEffect, useState } from "react"
import { IEvent } from "../../models/Event"
import { IGallery } from "../../models/Gallery";
import WSPGallery from "./components/WSPGallery";
import { HeaderTitle } from "../../components/HeaderTitle";

const ImagesComingSoon = () => (
  <div className="empty-state">
    <span className="material-icons">photo_library</span>
    <h2>תמונות יעלו בקרוב</h2>
  </div>
)

export const Gallery: React.FC<{ event: IEvent, pageHeader: Function }> = ({ event, pageHeader }) => {
  const [galleryImages, setGalleryItems] = useState<IGallery>()
  const [galleryJsonReceived, setGalleryJsonReceived] = useState(true)

  const fetchGallery = async () => {
    try {
      const response = await fetch(`https://www.4sport-live.com/miniSite/gallery?eventId=${event.eventId}`);
      const responseJson = await response.json();
      setGalleryJsonReceived(true)
      setGalleryItems(responseJson)
      return responseJson;
    } catch (error) {
      setGalleryJsonReceived(false)
      console.error(error);
    }
  }

  useEffect(() => {
    fetchGallery()
    pageHeader("גלריה")
  }, [])

  if (!galleryImages) return (
      <div className="min-height">
        <HeaderTitle titleText={'גלריה'} />
        {galleryJsonReceived ? <div style={{ top: '30vh' }} className="lds-ripple"><div></div><div></div></div> : <ImagesComingSoon />}
      </div>
  )

  return (
      <div className="main-gallery min-height">
        <HeaderTitle titleText={'גלריה'} />
        <div className="container section--tight">
          {(event.gallery || event.generalGallery) && <div className="gallery-links">
            {event.gallery &&
                <a className="btn btn-primary" href={event.gallery} target="_blank" rel="noreferrer">תמונות אישיות</a>
            }
            {event.generalGallery &&
                <a className="btn btn-outline" href={event.generalGallery} target="_blank" rel="noreferrer">תמונות כלליות</a>
            }
          </div>}

          {galleryImages.gallery?.length > 0 ?<WSPGallery galleryImages={galleryImages} /> : <ImagesComingSoon />}
        </div>
      </div >
  )
}
